export const DOCUMENTS_AREA = 'Documents';

export const DOCUMENT_CLICK = {
  area: DOCUMENTS_AREA,
  action: 'DocumentClick',
};
